import { Theme } from "./theme.model";

export const TunisiaTheme: Theme = {
  name: 'tunisia',
  properties: {
    '--app-color-base': '#fff',
    '--app-color-heading-5': '',
    '--app-color-white': '#fff',
    '--app-input-bg': '#F4F3F3',
    '--app-input-border-bg': '#DDDDDD',
    '--app-input-placeholder-bg': '#cccccc',
    '--app-color-primary': '#fff',
    '--app-color-primary-tint': '#d7d7d7',
    '--app-color-primary-tint-0': '',
    '--app-color-primary-tint-2': '',
    '--app-color-primary-tint-3': '',
    '--app-color-primary-tint-5': '',
    '--app-color-secondary': '#000',
    '--app-color-tertiary': '#fad63f',
    '--app-color-danger': '#F83D3C',
    '--app-color-header-about': '',
    '--app-color-btn-default': '#DDDDDD',
    "--app-color-promotions": "#fff",
    "--app-color-lexique": "#fff",
    "--app-color-checkbox-input-border-unchecked": "#777676e5",
    "--app-color-checkbox-input-border": "#fff",
    "--app-inactive-tab-color": "#999999",
    "--app-form-link-color": "#555555",
    "--app-partner-input-bg": "#F8F8F8",

    '--app-background-grey': '#9d9d9c ',
    '--app-background-grey-tint': '#5d5d5d ',
    '--app-background-base': '#004780',
    '--app-background-primary': '#013d6d',
    '--app-background-primary-tint': '#01569b',
    '--app-background-primary-tint-1': '#62b3f5',
    '--app-background-secondary': '#004d8c',
    '--app-background-secondary-tint': '#e85696',
    '--app-background-secondary-tint-1': '#c4640f',
    '--app-background-tertiary': '#023055',
    '--app-background-tertiary-tint': '#004780',
    '--app-background-tertiary-tint-1': '',
    '--app-btn-default-bg': '#DDDDDD',
    '--app-btn-default-bg-hover': '#C7C7C7',
    '--app-back-btn-bg': '#F4F3F3',
    '--app-btn-default-txt-color': '#3e3e3e',
    '--app-background-promotions': '#009d48',
    "--app-background-border-promotions": "#009d48",
    "--app-background-cmtJr": "#5d5d5d",
    "--app-background-lexique": "#5d5d5d",
    "--app-background-checkbox-input-unchecked": "#ffffffa4",
    "--app-background-checkbox-input": "#eb862c",
    "--app-step-default-bg": "#F4F3F3",
    "--app-step-default-txt-color": "#555555",
    "--app-step-active-bg": "#009D48",
    '--app-table-header-txt': '#777777',
    "--app-danger-bg": "#FF3030",
    "--app-danger-bg-2": "#FF5151"
  },
  socialMedia: {
    facebook: 'https://www.facebook.com/bet216.tn/',
    twitter: 'https://twitter.com/bet216',
    instagram: 'https://www.instagram.com/bet216/',
    linkedin: '',
    telegram: '',
    youtube: '',
    whatsapp: ''
  }
};
